// extracted by mini-css-extract-plugin
export var actionText = "_mm-4";
export var container = "_mm-0";
export var leftSection = "_mm-1";
export var rightSection = "_mm-2";
export var settingsButton = "_mm-6";
export var settingsIcon = "_mm-7";
export var shortcut = "_mm-5";
export var shortcutGroup = "_mm-3";